export const GENERAL_SUBDOMAIN = 'app';
export const COMMUNITY_SWITCHER_COOKIE = 'space-switcher-sbdmn';


export const communityUrlFromWindow = (window: any, subdomain: string, domain?: string | null) => {
  /*
   * CLIENT SIDE ONLY
   * ----------------
   * Builds community url from window object
   * window.location.hostname could be:
   * 1. <subdomain>.gokyg.com
   * 2. <app>.gokyg.com GENERAL_SUBDOMAIN
   * 3. custom-domain.io - custom domain
   *
   * if custom domain is present, we return custom domain
   * else: we replace <app>/<subdomain> with subdomain
   */
  let host;

  if (domain) {
    host = domain;
  } else {
    host = window.location.hostname.replace(GENERAL_SUBDOMAIN, subdomain);
  }

  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${host}${port}`;
};

export const generalHostFromWindow = (window: any) => {
  return GeneralHost(window.location.hostname);
};


export const GeneralHost = (host: string) => {
  // If already general subdomain, returns undefined
  const subdomain = SubdomainFromHost(host);
  if (subdomain == GENERAL_SUBDOMAIN) {
    // Already on GENERAL_SUBDOMAIN
    // app.gokyg.com, app.staging.gokyg.com, app.stage3.staging.gokyg.com, app.localhost.io
    return host;
  }

  if (host.includes('.localhost.io') || host.includes('.staging.gokyg.com') || host.includes('.gokyg.com')) {
    // Possible case:
    // 1. <subdomain>.localhost.io - local dev
    // 2. <subdomain>.staging.gokyg.com - staging
    // 3. <subdomain>.gokyg.com - production
    // redirect should be to GENERAL_SUBDOMAIN
    return host.replace(subdomain, GENERAL_SUBDOMAIN);
  }
  // Other cases:
  // kiite.co
  // kyg.me
  // uan.vc
  // these are kinda custom domains and also considered as general, so fine
  return host;
};

export const SubdomainFromHost = (host: string) => {
  if (['localhost', 'kiite.co', 'uan.vc', 'kyg.me'].includes(host)) {
    return ''
  }
  return host.split('.')[0];
}

export const GeneralCookieHost = (host: string) => {
  // if user is on subdomain host, cookie should be set on base host to be available from all subdomains
  // e.g. if user is on
  // app.gokyg.com, cookie should be set on pzm.gokyg.com
  // app.staging.gokyg.com, cookie should be set on pzm.staging.gokyg.com
  const cookieHost = host.replace(GENERAL_SUBDOMAIN, '');
  return cookieHost?.split(':')[0];
};
